const registerClick = (userData) => {
  userData.lastActionTimeStamp = new Date();
}

const UserClickTracker = {
  registerClick
}

export default UserClickTracker;